/**
 ********************************************************************************************
 * 설정
 ********************************************************************************************
 */

// STUDY_CAFE-Server URL
let HOST_URL;
let SYS_HOST_URL;
if (process.env.NODE_ENV == 'production') {
    // 250908 scsadmin ssl 인증서 적용하여 http > https로 변경
    // 250904 SSL 관련으로 HOST_URL 설정 변경 (http > https)
    HOST_URL = 'https://api.studycafe.momu24.com'; // for production
    SYS_HOST_URL = 'https://scsadmin.momu24.com';
} else {
    HOST_URL = 'http://localhost:8888'; // for develment
    SYS_HOST_URL = 'http://localhost:9999';
}
export const HOST = HOST_URL;
export const SYS_HOST = SYS_HOST_URL;

// 바코드관련 암호화 키
export const IV = 'dnflEkfdlQjwufk~';
export const ENCRYPTION_KEY = 'tkfkdgksmssoEkfthdbfdlrjsrkdgofk';

/**
 ********************************************************************************************
 * store actions 이름 정의
 ********************************************************************************************
 */

// store-actions- ACT_SERVER_REQUEST
export const ACT_SERVER_REQUEST = 'ACT_SERVER_REQUEST';
// store-actions- ACT_SERVER_REQUEST_ASYNC
export const ACT_SERVER_REQUEST_ASYNC = 'ACT_SERVER_REQUEST_ASYNC';
// store-actions- ACT_SERVER_REQUEST_ALL
export const ACT_SERVER_REQUEST_ALL = 'ACT_SERVER_REQUEST_ALL';
// store-actions- ACT_GET_INIT_DATA
export const ACT_GET_INIT_DATA = 'ACT_GET_INIT_DATA';


/**
 ********************************************************************************************
 * 서버 요청 type 정의
 ********************************************************************************************
 */

///////////////////
// 1. 로그인
///////////////////

// kiosk 단말 인증
export const REQ_SIGN_IN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/signin',
    method: 'post',
}
// kiosk 새로고침 시 인증
export const REQ_REDIRECT_SIGN_IN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/redirectSignin',
    method: 'post',
}
// kiosk 키값으로 인증
export const REQ_KEY_AUTH = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/keyAuthSignin',
    method: 'post',
}

// 로그인하기
export const REQ_MEMBER_LOGIN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/member/mobileLogin',
    method: 'post',
}

// 코드 추가 - 2020-12-09 [홍보앱 -> 키오스크 로그인]
export const REQ_MEMBER_PROMOTION_TO_LOGIN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/member/promotionToDoLogin',
    method: 'post',
}

// 모바일 인증
export const REQ_MOBILE_SIGN_IN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mobileSignin',
    method: 'post',
}

// 가입된 가맹점 조회
export const REQ_MEMBER_STORE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/store/get/list',
    method: 'post',
}

// 회원가입
export const REQ_MEMBER_USER_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/member/user/insert',
    method: 'post',
}

// 인증 요청
export const REQ_MEMBER_AUTH_REQ = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/member/auth/req',
    method: 'post',
}

// 인증 확인
export const REQ_MEMBER_AUTH_CHECK = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/member/auth/check',
    method: 'post',
}

// 토큰 갱신
export const REQ_MEMBER_AUTH_REFRESH = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/member/auth/refresh',
    method: 'post',
}



// 비밀번호 변경
export const REQ_MEMBER_USER_UPDATE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/member/user/update',
    method: 'post',
}

///////////////////
// 2. 메인
///////////////////

// 좌석 - 그룹맵
export const REQ_SEAT_TAB_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/tab/get/list',
    method: 'get',
}

// 좌석 - 개인석
export const REQ_SEAT_USER_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/user/get/list',
    method: 'get',
}

// 좌석 - 타입별 색깔 (범례)
export const REQ_SEAT_USER_GET_TYPE_COLOR_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/user/get/type/color/list',
    method: 'get',
}

// 좌석 - 상태별 색깔
export const REQ_SEAT_USER_GET_STATUS_COLOR_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/user/get/status/color/list',
    method: 'get',
}

// 좌석 - 내 좌석, 사물함 색깔
export const REQ_MY_COLOR_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/user/get/my/color/list',
    method: 'get',
}

// 좌석 - 사용중인 좌석
export const REQ_SEAT_USE_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/use/get',
    method: 'get',
}

// 좌석 - 사용중인 좌석 여부
export const REQ_SEAT_USE_GET_CHECK = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/use/check/get',
    method: 'get',
}
// 좌석 - 사용중인 다른좌석 시간값
export const REQ_ANOTHER_SEAT_USE_ENDTIME = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/endtime/get/list',
    method: 'get',
}

// 좌석 - 그룹룸 관련 정보 갖고오기
export const REQ_SEAT_GROOM_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/groom/get/list',
    method: 'get',
}
// 좌석 - 상품 설정여부 정보 조회
export const REQ_SEAT_GOODS_USE_YN_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/goods/useyn/get',
    method: 'get',
}
// 사물함 - 사물함 그룹맵 2020 09 01 추가
export const REQ_LOCKER_TAB_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/tab/get/list',
    method: 'get',
}

// 사물함 - 사물함
export const REQ_LOCKER_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/get/list',
    method: 'get',
}

// 사물함 - 상태별 색깔
export const REQ_LOCKER_USER_GET_STATUS_COLOR_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/user/get/status/color/list',
    method: 'get',
}

// 사물함 - 사용중인 사물함
export const REQ_LOCKER_USE_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/use/get',
    method: 'get',
}
// 사물함 - 사물함 상품 정보
export const REQ_LOCKER_GOODS_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/use/get/goodsinfo',
    method: 'post',
}

// 그룹룸 - 그룹룸
export const REQ_GROOM_GROUPROOM_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/groupRoom/get/list',
    method: 'get',
}

// 그룹룸 - 사용중인 좌석 여부
export const REQ_GROOM_USE_CHECK = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/use/check',
    method: 'get',
}
// 그룹룸 - 사용중인 좌석 여부
export const REQ_GROOM_USE_SELECT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/use/select',
    method: 'get',
}

// 그룹룸 - 타입별 색깔 (범례)
export const REQ_GROOM_USER_GET_TYPE_COLOR_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/user/get/type/color/list',
    method: 'get',
}

// 그룹룸 - 상태별 색깔
export const REQ_GROOM_USER_GET_STATUS_COLOR_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/user/get/status/color/list',
    method: 'get',
}

// 그룹룸 - 사용중인 그룹룸
export const REQ_GROOM_USE_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/use/get',
    method: 'get',
}
// 그룹룸 - 즉시사용시 중복 사용 방지를 위한 상태 체크
export const REQ_GROOM_STATUS_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/status/get',
    method: 'get',
}
// 그룹룸 - 당일 예약 현황
export const REQ_GROOM_TODAY_RESERVATION_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/today/reservation/get/list',
    method: 'get',
}
// 매장 마일리지 및 할인쿠폰 사용여부
export const REQ_MILEAGE_AND_SALE_USE_YN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/useyn/get',
    method: 'get',
}

// 그룹룸 - 모바일 그룹룸 별도상품구매 여부 251113 추가
export const REQ_FEATURE_FLAG_YN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/feature_config/get',
    method: 'get',
}

// 사용중인 좌석이 있을 경우 사용 시간 업데이트
export const REQ_SEAT_USE_LEFT_TIME = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/use/time/get',
    method: 'post',
}
// 퇴실임박좌석
export const REQ_OUT_SOON = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/out/soon',
    method: 'get',
}

///////////////////
// 3. 상품구매
///////////////////

// 좌석- 가격표
export const REQ_SEAT_PRICE_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/price/get/list',
    method: 'get',
}

// 사물함 - 가격표
export const REQ_LOCKER_PRICE_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/price/get/list',
    method: 'get',
}

// 그룹룸 - 가격표
export const REQ_GROOM_PRICE_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/price/get/list',
    method: 'get',
}
// 마일리지 - 가격표
export const REQ_MILEAGE_PRICE_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mileage_price/get/list',
    method: 'get',
}
// 251127 기타상품 - 가격표
export const REQ_ETC_PRICE_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/etc_price/get/list',
    method: 'get',
}
// 251127 상품구매 - 기타 상품 리스트
export const REQ_ETC_GOODS_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/etc_goods/get/list',
    method: 'get',
}
// 251127 기타상품 - 관리자 설정체크
export const REQ_ETC_USE_CHECK = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/etc_price/use/check',
    method: 'get',
}
// 251127 기타 상품구매 - 결제하기
export const REQ_ETC_PAYMENT_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/goods/etc/insert',
    method: 'post',
}

// 상품구매 - 좌석 타입 리스트
export const REQ_SEAT_TYPE_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/type/get/list',
    method: 'get',
}

// 상품구매 - 좌석 상품 리스트
export const REQ_SEAT_GOODS_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/goods/get/list',
    method: 'get',
}
// 상품구매 - 좌석 상품 리스트
export const REQ_MILEAGE_GOODS_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mileage_goods/get/list',
    method: 'get',
}

// 모바일 - 상품구매 - 좌석 시간 리스트
export const REQ_M_SEAT_TIME_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/m/time/get/list',
    method: 'get',
}

// 모바일 - 상품구매 - 좌석 시간선택(행사)
export const REQ_M_SEAT_EVENT_TIME_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/m/event/time/get/list',
    method: 'get',
}

// 상품구매 - 좌석 시간 리스트
export const REQ_SEAT_TIME_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/time/get/list',
    method: 'get',
}

// 상품구매 - 좌석 시간선택(행사)
export const REQ_SEAT_EVENT_TIME_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/event/time/get/list',
    method: 'get',
}

// 상품구매 - 좌석 시간선택(쿠폰)
export const REQ_SEAT_COUPON_TIME_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/coupon/time/get/list',
    method: 'get',
}

// 상품구매 - 그룹룸 상품 리스트
export const REQ_GROOM_GOODS_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/goods/get/list',
    method: 'get',
}

// 상품구매 - 그룹룸 상품 리스트(2)
export const REQ_GROOM_GOODS_SEL_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/goodsSel/get/list',
    method: 'get',
}

// 상품구매 - 그룹룸 시간선택
export const REQ_GROOM_GOODS_TIME_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/goods/time/get/list',
    method: 'get',
}

// 상품구매 - 마일리지 조회
export const REQ_MILEAGE_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mileage/get',
    method: 'get',
}

// 상품구매 - 마일리지 사용
export const REQ_MILEAGE_USE_UPDATE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mileage/use/update',
    method: 'post',
}

// 상품구매 - 마일리지 이력 insert
export const REQ_MILEAGE_USE_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mileage/use/insert',
    method: 'post',
}

// 상품구매 - 할인쿠폰 적용 확인
export const REQ_COUPON_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/coupon/get',
    method: 'get',
}

// 상품구매 - 결제하기
export const REQ_PAYMENT_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/payment/insert',
    /* url: '/kiosk/payment/mobile/insert', // 20-12-21 백업*/
    method: 'post',
}
// 마일리지 상품구매 - 결제하기
export const REQ_MILIEAGE_PAYMENT_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/goods/mileage/insert',
    method: 'post',
}

// 좌석 구매 이력 등록
export const REQ_SEAT_PURCHASE_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/purchase/insert',
    method: 'post',
}

// 사물함 구매 이력 등록
export const REQ_LOCKER_PURCHASE_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/purchase/insert',
    method: 'post',
}

// 그룹룸 구매 이력 등록
export const REQ_GROOM_PURCHASE_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/purchase/insert',
    method: 'post',
}

///////////////////
// 4. 마이페이지
///////////////////

// 내연장 상품 상세정보
export const REQ_MY_SEAT_EXTENGOODS_GET_INFO = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mypage/seat/extenGoods/get/info',
    method: 'get',
}

// 내상품 목록
export const REQ_MYPAGE_SEAT_GOODS_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mypage/seat/goods/get/list',
    method: 'get',
}

// 내상품 그룹 목록
export const REQ_MYPAGE_SEAT_GOODS_GET_GROUPS = {
  action_name: ACT_SERVER_REQUEST,
  url: '/kiosk/mypage/seat/goods/get/groups',
  method: 'get',
}

// 내 쿠폰목록
export const REQ_MYPAGE_COUPON_GOODS_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mypage/coupon/goods/get/list',
    method: 'get',
}

// 내 좌석 정보
export const REQ_MYPAGE_SEAT_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mypage/seat/get',
    method: 'get',
}

// 내 사물함 정보
export const REQ_MYPAGE_LOCKER_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mypage/locker/get',
    method: 'get',
}

// 내 그룹룸 상품목록
export const REQ_MYPAGE_GROOM_GOODS_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mypage/groom/goods/get/list',
    method: 'get',
}

// 내 그룹룸 상품목록(타입별)
export const REQ_MYPAGE_GROOM_TYPE_GOODS_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mypage/groom/type/goods/get/list',
    method: 'get',
}

// 내 그룹룸 예약 목록
export const REQ_MYPAGE_GROOMRESERV_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mypage/groomReserv/get/list',
    method: 'get',
}

// 250724 내 그룹룸 이용내역
export const REQ_MYPAGE_GROOMHISTORY_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mypage/groomUsing/get/list',
    method: 'get',
}

///////////////////
// 5. [탭] 좌석
///////////////////

// 이용 연장
export const REQ_SEAT_USE_UPDATE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/use/update',
    method: 'post',
}
// 그룹룸 이용 연장
export const REQ_GROOM_USE_UPDATE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/use/update',
    method: 'post',
}

// 이용 종료
export const REQ_SEAT_USE_DELETE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/use/delete',
    method: 'post',
}
// 그룹룸 이용 종료
export const REQ_GROOM_USE_DELETE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/use/delete',
    method: 'post',
}

// 자리이동
export const REQ_SEAT_MOVE_UPDATE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/move/update',
    method: 'post',
}

// 상품선택 - 좌석배정
export const REQ_SEAT_USE_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/use/insert',
    method: 'post',
}

///////////////////
// 6. [탭] 사물함
///////////////////

// 이용연장
export const REQ_LOCKER_USE_UPDATE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/use/update',
    method: 'post',
}

// 이용종료
export const REQ_LOCKER_USE_DELETE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/use/delete',
    method: 'post',
}

// 자리이동
export const REQ_LOCKER_MOVE_UPDATE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/move/update',
    method: 'post',
}

// 사물함 상품 목록
export const REQ_LOCKER_GOODS_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/locker/goods/get/list',
    method: 'get',
}

///////////////////
// 7. [탭] 그룹룸
///////////////////

// 그룹룸 배정
export const REQ_GROOM_USE_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/use/insert',
    method: 'post',
}

// 상품선택 - 그룹룸 시간선택
export const REQ_GROOM_TIME_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/time/get/list',
    method: 'get',
}
// 상품선택 - 그룹룸 인원수별 선택
export const REQ_GROOM_PERSON_GET_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/person/get/list',
    method: 'get',
}

// 그룹룸 예약
export const REQ_GROOM_RESERVATION_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/reservation/insert',
    method: 'post',
}

// 좌석/그룹룸/사물함 탭 생성
export const REQ_GET_GOODS_TYPE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/goods/type/get/list',
    method: 'get',
}

// 그룹룸 예약 시 그룹룸 정보 리스트
export const REQ_GET_GROOM_RESERV_INFO_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/reserv/info/get/list',
    method: 'get',
}
export const REQ_GET_GROOM_MY_TIMEPRODUCT_INFO_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/reserv/time_product/get/list',
    method: 'get',
}

// 그룹룸 시간 선택시 예약이 있는지 검사
export const REQ_GROOM_RESERV_CHECK = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/reserv/check',
    method: 'get',
}
// 그룹룸 예약시 선택한 시간에 따른 중복 예약건 체크
export const REQ_GROOM_RESERV_OVERLAP_CHECK = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/reserv/overlap/check',
    method: 'get',
}
// 그룹룸 이용연장 여부 검사
export const REQ_GROOM_CONTINUE_CHECK = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/continue/check',
    method: 'get',
}

// 그룹룸 예약시 해당 그룹룸의 시간대별 예약 현황을 갖고옴
export const RES_GET_GROOM_RESERV_INFO_TIME_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/reserv/info/time/get/list',
    method: 'get',
}

// 고정석 종료 시 부모님에게 문자보내기
export const REQ_PARENTS_SEND_SMS = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/parents/send/sms',
    method: 'get',
}
// 260108 고정석 종료 시 본인에게 문자보내기
export const REQ_USER_OUT_SEND_SMS = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/user/out_send/sms',
    method: 'get',
}

// 좌석 / 사물함 / 그룹룸 구매프로세스 로직 진입시 상태를 결제중 으로 업데이트 해주기
export const REQ_UPDATE_LOCK_STATUS = {
  action_name: ACT_SERVER_REQUEST,
  url: '/kiosk/update/status/lock',
  method: 'get',
}
// 좌석 LOCK 시간 연장
export const REQ_UPDATE_LOCK_EXTENTION_STATUS = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/update/status/lock_extention',
    method: 'get',
}

// 그룹룸 예약번호 확인
export const REQ_RESERVATION_NUMBER_CONFIRM = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/reservation/confirm',
    method: 'get',
}
// 좌석 / 사물함 / 그룹룸 구매프로세스 로직 진입시 상태를 사용가능 으로 업데이트 해주기
export const REQ_UPDATE_AVAILABLE_STATUS = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/update/status/available',
    method: 'get',
}

// 그룹룸 예약번호 확인
export const REQ_RESERVATION_GOODS_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/reservation/goods/get',
    method: 'get',
}

///////////////////
// 100. template
///////////////////
// 광고 출력할 리스트 불러오기
export const REQ_GET_ADV_PLAYLIST_SEARCH ={
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/adv/playList/search',
    method: 'get',
}

// 출력 정보 불러오기
export const REQ_GET_RECEIPT_INFO ={
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/receiptInfo',
    method: 'get',
}
// 바코드 정보 불러오기
export const REQ_GET_BARCODE_INFO ={
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/member/getBarcodeInfo',
    method: 'get',
}

export const REQ_GET_SESSION_CHECK ={
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/getSessionCheck',
    method: 'get',
}
export const REQ_REDIRECT_COUNT ={
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/redirectCount',
    method: 'get',
}

export const REQ_PAYMENT_CANCEL_UPDATE ={
    action_name: ACT_SERVER_REQUEST,
    url: '/payment/kioskPaymentCancel',
    method: 'get',
}
export const REQ_PAYMENT_DAY_LIST ={
    action_name: ACT_SERVER_REQUEST,
    url: '/payment/kioskPaymentDayList',
    method: 'get',
}
export const REQ_RECEIPT_REPRINT_INFO = {
    action_name: ACT_SERVER_REQUEST,
    url: '/payment/kioskReceiptReprint',
    method: 'get',
}

export const REQ_ADMIN_LOGIN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/member/kioskAdminLogin',
    method: 'post',
}
export const REQ_DOOR_SINGLE_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/door/kioskUseSingle',
    method: 'get',
}
export const REQ_DOOR_GROUP_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/door/kioskUseGroup',
    method: 'get',
}
export const REQ_GROOM_PASS_GET_INFO = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/pass/info/get',
    method: 'get',
}
export const REQ_USING_SEAT_CHECK = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seat/using/check',
    method: 'get',
}
export const REQ_ = {
    action_name: ACT_SERVER_REQUEST,
    url: '',
    method: '',
}
///////////////////
//  모바일
///////////////////
export const REQ_ITEM_CURRENT_SITUATION_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/itemCurrentSituation/get',
    method: 'post',
}

export const REQ_JOIN_STORE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/joinStore/list/get',
    method: 'get',
}
// 인증 요청
export const REQ_MOBILE_MEMBER_AUTH_REQ = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/auth/req',
    method: 'post',
}

// 인증 확인
export const REQ_MOBILE_MEMBER_AUTH_CHECK = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/auth/check',
    method: 'post',
}
// 비밀번호 변경
export const REQ_MOBILE_MEMBER_USER_UPDATE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/password/update',
    method: 'post',
}
// 사용중인 좌석 메인 type
export const REQ_SEAT_MAIN_TYPE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/seatType/get',
    method: 'post',
}
// 매장 좌석/그룹룸/사물함 이미지 정보 조회
export const REQ_STORE_GOODS_TYPE_IMAGE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/goods/type/img/get/list',
    method: 'get',
}
// 매장 옵션
export const REQ_STORE_OPTION = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/getStoreOption',
    method: 'get',
}

// 마일리지 세팅
export const REQ_GET_MILEAGE_SETTINGS = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/mileage_settings/get/list',
    method: 'get',
}


// 모바일 결제 로그 추가
export const REQ_GROOM_MOBILE_CALLBACK_LOG_INSERT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/groom/mobile/callback/log/insert',
    method: 'post',
}
// 환불규정 불러오기
export const REQ_REFUND_GET = {
    action_name: ACT_SERVER_REQUEST,
    url: '/kiosk/getrefund',
    method: 'get',
}
// 250514 결제시 이용안내 데이터 불러오기
export const REQ_GET_USAGE_GUIDE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/usageGuide',
    method: 'post',
}


// WEBPACK FOOTER //
// ./src/javascript/config.js